var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrush1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.175 3.28699C17.0834 6.01199 14.5917 9.57032 12.2167 11.8953C11.875 9.74532 10.1584 8.06199 7.9917 7.76199C10.325 5.37866 13.9084 2.85366 16.6417 1.75366C17.125 1.57032 17.6084 1.71199 17.9084 2.01199C18.225 2.32866 18.375 2.80366 18.175 3.28699Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4834 12.5745C11.3168 12.7161 11.1501 12.8578 10.9834 12.9911L9.49176 14.1828C9.49176 14.1578 9.48343 14.1245 9.48343 14.0911C9.36676 13.1995 8.9501 12.3745 8.2751 11.6995C7.59176 11.0161 6.74176 10.5995 5.80843 10.4828C5.78343 10.4828 5.7501 10.4745 5.7251 10.4745L6.93343 8.94948C7.0501 8.79948 7.1751 8.65781 7.30843 8.50781L7.8751 8.58281C9.66676 8.83281 11.1084 10.2411 11.3918 12.0245L11.4834 12.5745Z",
    fill: "#FB4764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69155 14.684C8.69155 15.6007 8.34155 16.4757 7.67489 17.134C7.16655 17.6507 6.48322 18.0007 5.64989 18.1007L3.60822 18.3257C2.49155 18.4507 1.53322 17.4923 1.65822 16.3673L1.88322 14.3173C2.08322 12.4923 3.60822 11.3257 5.22489 11.2923C5.38322 11.284 5.55822 11.2923 5.72489 11.309C6.43322 11.4007 7.11655 11.7257 7.69155 12.2923C8.24989 12.8507 8.56655 13.509 8.65822 14.2007C8.67489 14.3673 8.69155 14.5257 8.69155 14.684Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush1);
export default __webpack_public_path__ + "static/media/brush-1.27b761b6362deac7fba9171860b2cb9e.svg";
export { ForwardRef as ReactComponent };